import { renderFlags } from "../engines/layoutEngine/renderFlags";

type AppState = {
  resolution: number;
  localCursorPosition: { x: number; y: number };
  shouldShowStepFlowLines: boolean;
};

const _appState: AppState = {
  resolution: 1,
  shouldShowStepFlowLines: false,
  // should we store the cursor position in the app state? TODO- check if this is the right place to store it
  localCursorPosition: { x: -Infinity, y: -Infinity }
};
export const appState = new Proxy(_appState, {
  get(obj, prop: keyof typeof _appState) {
    return obj[prop];
  },
  set(obj, prop: keyof AppState, value: never) {
    obj[prop] = value;
    if (prop === "resolution") {
      renderFlags.layoutDirty = true;
    }
    if (prop === "shouldShowStepFlowLines") {
      renderFlags.domDirty = true;
    }
    // According to the Proxy specification, the set trap must return a boolean value
    // Return true to indicate that the property was set successfully
    // Return false to indicate that the set operation failed (which will throw a TypeError in strict mode)
    return true;
  }
});
